// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3wjqQWF2 clearfix","list":"list-XbBgursM"};